import endpoints from 'libs/src/config/endpoints';
import { BlogAxios } from '../../NetworkHelper';

export const fetchAllCareers = async (
  pageNumber = 1,
  size = 60,
): Promise<any> => {
  try {
    let data = await BlogAxios.get(
      `/api${endpoints.careers}&pagination[page]=${pageNumber}&pagination[pageSize]=${size}`,
    );
    return data.data;
  } catch (error) {
    return [];
  }
};
